var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.474,
    height: 20.549,
    viewBox: "0 0 24.474 20.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_631",
    "data-name": "Groupe 631",
    transform: "translate(-435.966 -470.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_937",
    "data-name": "Trac\\xE9 937",
    d: "M460.482,475.833a.857.857,0,0,0-1.168.321l-1.174,2.065a.128.128,0,0,1-.237-.036,9.808,9.808,0,0,0-18.538-1.53c-.46,1.273,1.526,2.045,2.2.6.027-.057.057-.1.085-.15a7.554,7.554,0,0,1,14.089,1.685.137.137,0,0,1-.2.147l-2.068-1.175a.857.857,0,1,0-.847,1.491l4.357,2.477a.989.989,0,0,0,1.349-.372L460.8,477A.857.857,0,0,0,460.482,475.833Z",
    transform: "translate(-0.475)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_938",
    "data-name": "Trac\\xE9 938",
    d: "M436.4,487.71a.857.857,0,0,0,1.168-.321l1.174-2.065a.128.128,0,0,1,.237.036,9.808,9.808,0,0,0,18.538,1.53c.46-1.273-1.526-2.045-2.2-.6-.027.057-.057.1-.085.15a7.554,7.554,0,0,1-14.089-1.685.137.137,0,0,1,.2-.147l2.068,1.175a.857.857,0,1,0,.847-1.491l-4.357-2.476a.989.989,0,0,0-1.349.371l-2.476,4.357A.857.857,0,0,0,436.4,487.71Z",
    transform: "translate(0 -1.566)",
    fill: "#181a3a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.cd3d4d986ce0f6c6c195ebc46c5fdef0.svg";
export { ForwardRef as ReactComponent };